import React, { useRef, useEffect } from 'react';
import QRious from 'qrious';

const QRCode = ({text, size, className}) => {
  const canvas = useRef(null);
  useEffect(() => {
    if (canvas != null && canvas.current != null) {
      let qr = new QRious({
        element: canvas.current,
          value: text,
          size: size
      });
    }
  });
  return(<canvas className={className} ref={canvas}></canvas>);
}

export default QRCode;
